import logo from '../../assets/images/rexolms.png'

export default function FallbackPage() {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center" style={{ backgroundColor: '#fff', height: '100vh' }}>
                <div className="text-white text-center">
                    <img src={logo} alt="lg" className="img-fluid zoom-animation" style={{ width: '70%' }} />
                </div>
            </div>
        </>
    )
}